var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcLiquidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.547 1.67695C15.3974 1.46763 15.2 1.29703 14.9712 1.17934C14.7424 1.06164 14.4888 1.00024 14.2315 1.00024C13.9742 1.00024 13.7206 1.06164 13.4918 1.17934C13.263 1.29703 13.0656 1.46763 12.916 1.67695C9.89299 6.05495 2.69299 16.97 2.69299 21.757C2.69299 27.817 7.85899 32.731 14.231 32.731C20.603 32.731 25.77 27.817 25.77 21.757C25.77 16.97 18.573 6.05495 15.547 1.67695Z",
    fill: "#04F4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.086 7.446C26.9364 7.23667 26.739 7.06608 26.5102 6.94838C26.2814 6.83069 26.0278 6.76929 25.7705 6.76929C25.5132 6.76929 25.2596 6.83069 25.0308 6.94838C24.802 7.06608 24.6046 7.23667 24.455 7.446C21.432 11.824 14.232 22.739 14.232 27.526C14.232 33.586 19.398 38.5 25.77 38.5C32.142 38.5 37.309 33.586 37.309 27.526C37.309 22.739 30.112 11.824 27.086 7.446Z",
    fill: "#AC6AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.231 27.526C14.231 23.874 18.421 16.653 21.752 11.491C23.952 15.391 25.769 19.349 25.769 21.757C25.7088 24.5108 24.6348 27.1457 22.7527 29.1569C20.8707 31.1681 18.3128 32.4144 15.569 32.657C14.6916 31.0892 14.2309 29.3226 14.231 27.526H14.231Z",
    fill: "#72F5FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLiquidity);
export default __webpack_public_path__ + "static/media/ic_liquidity.ee82c1f789fba6b4e20ee310151a414f.svg";
export { ForwardRef as ReactComponent };